import axios from '@/axios-api';
import Pathes from '@/helpers/pathes';
import { getQuery } from '@/helpers/utils';

export const chatwootService = {
  getIdentity: params =>
    axios.get(Pathes.Common.chatwootIdentity + getQuery(params)),
};